<template>
  <span>
    <span class="articlenumber small text-muted" v-if="bullet.Name && bullet.Value">
      <b>{{  bullet.Name }}</b>
      <span v-if="bullet.url"><a @click="getCategoryDescription()"  data-toggle="modal" href="#shippingscosts" title="Mehr Informationen" >{{ bullet.Value }}</a></span>
      <span v-else>{{ bullet.Value }}</span>
    </span><br v-if="bullet.Name && bullet.Value"/>
  </span>
</template>
<script>
const ApiService = require("../../services/ApiService");

export default {
    props:
    {
        bullet:
        {
            type:  [Object, Array, String, Boolean]
        },

        variationProperty:
        {
            type:  [Object, Array]
        }
    },
  methods:
      {
        getCategoryDescription()
        {
          const categoryId = this.bullet.url;
          ApiService.get("/ks/categorydescription/"+categoryId,{}, {dataType: "html", headers: { "Accept": "text/html; charset=utf-8"} })
              .done(response =>
              {
                $(".modal-title").html( this.bullet.Name );
                $(".shipping-modal-body").html(response);
              });
        }
      }
}
</script>
